import { useCatalogItemCartContext } from '../../../../providers/CatalogItemCartProvider'
import { CatalogItemDetailsPanel } from '../../views/CatalogItemDetailsPanel'

export const CatalogItemDetailsPanelPresenter = () => {
  const {
    selectedItem,
    quantity,
    estimatedTotal,
    changeQuantity,
    addToRequest,
    askFollowUp,
    collapse,
  } = useCatalogItemCartContext()

  if (!selectedItem) return null

  return (
    <CatalogItemDetailsPanel
      item={selectedItem}
      quantity={quantity}
      estimatedTotal={estimatedTotal}
      onQuantityChange={changeQuantity}
      onAddToRequest={addToRequest}
      onChipSelect={askFollowUp}
      onCollapse={collapse}
    />
  )
}
